module.exports = __webpack_public_path__ + "img/87acd94.png";